import React from "react";
import { useSelector } from "react-redux";
import ModalRoot from "components/Modal";

const ModalsHolder = () => {
  const modals = useSelector((state) => state.modals);
  return (
    <>
      {modals.map((modal) => (
        <ModalRoot modalType={modal.modalType} modalProps={modal.modalProps} />
      ))}
    </>
  );
};

export default ModalsHolder;
